import moment, { Moment } from 'moment';

export const HOUR_WITH_TIMEZONE = 'hh:mm A z';
export const DEFAULT_DATE_FORMAT = 'ddd, MMM D';
export const CONSENT_SIGNED_AT_FORMAT = '[Date:] MM/DD/YYYY [| Time:] hh:mm A z';

/**
 * Sanitizes date strings for Safari compatibility.
 * Safari fails to parse dates in format "YYYY-MM-DD HH:mm:ss UTC" (Rails Time#to_s).
 * Converts to ISO 8601 format which all browsers support: "YYYY-MM-DDTHH:mm:ssZ"
 */
const safariSafeDate = (date: string | Date): string | Date => {
  if (typeof date === 'string') {
    // Convert Rails Time#to_s format to ISO 8601
    // "2024-08-07 14:15:00 UTC" → "2024-08-07T14:15:00Z"
    return date.replace(/^(\d{4}-\d{2}-\d{2}) (\d{2}:\d{2}:\d{2}) UTC$/, '$1T$2Z');
  }
  return date;
};

export const formatDate = (date: string | Date, format = 'MM/DD/YYYY') =>
  moment(safariSafeDate(date)).format(format);

export const formatDateUtc = (date: string | Date, format = 'MM/DD/YYYY') =>
  moment.utc(safariSafeDate(date)).format(format);

export const stringToDate = (date: string, format = 'MM/DD/YYYY') => moment(date, format).toDate();

export const dateToString = (date: Date) => date.toISOString().split('T')[0];

export const getUtcDate = (date: Date) =>
  new Date(date.getTime() - date.getTimezoneOffset() * 60000);

export const stringToDateUTC = (date: string) => new Date(`${date}T00:00:00`);

export const getMonthStartDateTime = (currentMonth?: Moment) =>
  currentMonth?.clone().startOf('month') || moment.utc().startOf('month');
